export default __webpack_public_path__ + "static/media/Logo_Horizontal.f934b92b.png";